export enum eSubscriptionStatus {
  NOT_PROCESSED,
  CREATED,
  ALREADY_EXISTS,
  UNKNOWN_ERROR,
  PAYMENT_FAILED,
}

export interface CreateSubscriptionData {
  planIdentifier: string;
  priceId: string;
}

export interface IsPremiumCache {
  is_premium: boolean;
}

export interface StripeItem {
  id: number;
  subscription_id: number;
  stripe_id: string;
  stripe_product: string;
  stripe_price: string;
  quantity: number;
  created_at: string;
  updated_at: string;
}

export enum eStripeStatus {
  TRIALING = "trialing",
  ACTIVE = "active",
  PAST_DUE = "past_due",
  CANCELED = "canceled",
  INCOMPLETE = "incomplete",
  INCOMPLETE_EXPIRED = "incomplete_expired",
  UNPAID = "unpaid",
}

export interface UserSubscription {
  id: number;
  user_id: number;
  name: string;
  stripe_id: string;
  stripe_status: eStripeStatus;
  stripe_price: string;
  quantity: number;
  trial_ends_at: string;
  ends_at: any;
  created_at: string;
  updated_at: string;
  items: StripeItem[];
  last_user_update?: string;
}

export interface UpdateSubscriptionRequest {
  planIdentifier: string;
  priceId: string;
}

export interface UpdateSubscriptionResponse {
  msg: string;
  status: number;
}
